if (!customElements.get('fast-simon-upsell-tab')) {
  class FastSimonUpsellTab extends HTMLElement {
    constructor() {
      super();
      this.widgetId = this.dataset.widgetId;
      this.seedProductId = this.dataset.seedProductId;
    }

    connectedCallback() {
      if (!this.widgetId || !this.seedProductId || this.seedProductId === 'null') return;

      if (window.FastSimonSDK) {
        this.fetchRecs();
      } else {
        document.addEventListener('fastsimon:ready', () => this.fetchRecs(), { once: true });
      }
    }

    fetchRecs() {
      window.FastSimonSDK.productRecommendationByWidget({
        productID: this.seedProductId,
        widgetsIDS: [this.widgetId],
        withAttributes: false,
        callback: (response) => {
          const widgetPayload = response?.payload?.[0]?.payload ?? [];
          if (!widgetPayload.length) return;

          this.innerHTML = widgetPayload.map((item) => `
            <div class="swiper-slide">
              <intersection-loader data-url="${item.u}" data-section-id="cart-upsell-tile"></intersection-loader>
            </div>
          `).join('');

          this.closest('swiper-carousel')?.slider?.update();
        }
      });
    }
  }

  customElements.define('fast-simon-upsell-tab', FastSimonUpsellTab);
}
